import { Injectable }     from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot }    from '@angular/router';

@Injectable()
export class ExternalRoutesGuard  {
    
    constructor(){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean | Promise<boolean> {
        const externalUrl = route.paramMap.get('externalUrl');
        window.location.href = externalUrl;
        return false;
    }
}
